import { z } from "zod";
import { ISODateSchema, ULIDSchema } from "./primitives.js";
export const UnitsSchema = z.enum(["metric", "imperial"]);
export const TimerPrefsSchema = z.object({
    soundEnabled: z.boolean().default(true),
    vibrateEnabled: z.boolean().default(true),
});
export const CookingSplitSchema = z.enum(["70-30", "60-40", "40-60"]);
export const UserPrefsSchema = z
    .object({
    units: UnitsSchema.default("metric"),
    locale: z.string().min(2).max(10).default("en-US"),
    timer: TimerPrefsSchema.default({ soundEnabled: true, vibrateEnabled: true }),
    cookingSplit: CookingSplitSchema.default("60-40"),
    mealPlanDailyEmail: z.boolean().default(true),
})
    .passthrough();
// userId = raw Cognito sub (UUID v4 shape). Permissive schema; see "Resolved scope
// decisions" #9 in the plan front-matter for the rationale.
export const UserIdSchema = z
    .string()
    .min(8)
    .max(128)
    .regex(/^[A-Za-z0-9_-]+$/, "userId must be alphanumeric (Cognito sub format)");
export const UserSchema = z
    .object({
    userId: UserIdSchema,
    schemaVersion: z.literal(1),
    displayName: z.string().min(1).max(80),
    email: z.string().email(),
    currentHouseholdId: ULIDSchema("hh").nullable(),
    prefs: UserPrefsSchema,
    createdAt: ISODateSchema,
    updatedAt: ISODateSchema,
})
    .passthrough();
export const PatchMeRequestSchema = z
    .object({
    displayName: z.string().min(1).max(80).optional(),
    prefs: UserPrefsSchema.partial().optional(),
})
    .strict()
    .refine((v) => v.displayName !== undefined || v.prefs !== undefined, {
    message: "At least one of displayName or prefs must be provided",
});
//# sourceMappingURL=user.js.map